import React from "react";
import {Link} from "gatsby";

export default function Title({post, type}) {
  if (type === "category" || type === "tag") {
    return (
      <h2 className="post-z-c1-title">
        <Link
          to={`${post.slug}/`}
          key={post.id}
          className="post-z-c1-link"
        >
          {/* <i className="c-icon c-icon-tutorial c-post-icon" /> */}
          {post.title}
        </Link>
      </h2>
    );
  }
  if (type === "post") {
    return (
      <h1 className="post-z-c1-title">
        {/* <i className="c-icon c-icon-tutorial c-post-icon" /> */}
        {post.title}
      </h1>
    );
  }
  if (type === "page") {
    return (
      <h2 className="post-z-c1-title">
        <Link
          to={`${post.slug}/`}
          key={post.id}
          className="post-z-c1-link"
        >
          {/* <i className="c-icon c-icon-tutorial c-post-icon" /> */}
          {post.title}
        </Link>
      </h2>
    );
  }
}

